import PermissionDenied from "@/components/Common/PermissionDenied";
import Invoices from "@/components/Invoices/Invoices";
import {useIsAdmin, useSelectedCompanyId} from "@/hooks/useUserHooks";
import {selectedCompanyIdAtom} from "@/store/jotaiAtoms";
import useUserStore from "@/store/user";
import {createFileRoute} from "@tanstack/react-router";
import {getDefaultStore} from "jotai";

export const Route = createFileRoute("/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/invoices")({
  component: AgencySubbrandInvoices,
  params: {
    parse: raw => ({
      agencyId: +raw.agencyId,
      companyId: +raw.companyId,
    }),
    stringify: params => ({
      agencyId: params.agencyId?.toString(),
      companyId: params.companyId?.toString(),
    }),
  },
  loader: ({params}) => {
    getDefaultStore().set(selectedCompanyIdAtom, params.companyId);
  },
});

function AgencySubbrandInvoices() {
  const navigate = Route.useNavigate();
  const {agencyId, companyId} = Route.useParams();
  const user = useUserStore(state => state.user);
  const isAdmin = useIsAdmin();
  const selectedCompanyId = useSelectedCompanyId();

  const isViewingSelf =
    user.sub_brands?.find(subBrand => subBrand.company.id === +companyId) && companyId === selectedCompanyId;

  if (!isAdmin && !isViewingSelf) {
    return <PermissionDenied />;
  }

  return (
    <Invoices
      onBack={() => navigate({to: "/agency/$agencyId/subbrand/$companyId/dashboard", params: {agencyId, companyId}})}
    />
  );
}
